import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function FaqList({ faqs, testIdPrefix, className = "mt-4 space-y-3" }) {
  return (
    <div className={className}>
      {faqs.map((faq, index) => (
        <details key={faq.id || faq.q} className="abc-card p-5 group" data-testid={testIdPrefix ? `${testIdPrefix}-${index}` : undefined}>
          <summary className="cursor-pointer list-none flex justify-between items-start gap-4">
            <span className="font-display font-bold text-[#1A1D21]">{faq.q}</span>
            <ArrowRight className="w-4 h-4 text-[#54616E] flex-shrink-0 mt-1 group-open:rotate-90 transition" />
          </summary>
          <p className="mt-3 text-slate-600 leading-relaxed">
            {faq.a}
            {faq.link && (
              <Link to={faq.link.to} className="text-[#E31D2B] font-semibold underline underline-offset-2 hover:text-[#B71420]" data-testid="faq-inline-link">
                {faq.link.label}
              </Link>
            )}
            {faq.aEnd}
          </p>
        </details>
      ))}
    </div>
  );
}
